export default __webpack_public_path__ + "assets/images/694cc4e9662d663534d72c206c1673bf.svg";